import { createContext, useCallback, useMemo, useState } from 'react'

import { useGetUserQuery } from 'common'
import { dispatchSegmentEvent } from 'features/tracked_meetings/status/completed/useSegment'
import { useTrack } from 'hooks/analytics_events'
import {
  useDeleteMeetingSharePasscodeMutation,
  usePatchMeetingSharePasscodeMutation,
  usePostMeetingShareMutation
} from 'hooks/meeting_shares/api'

export const ShareContext = createContext({})
export const ShareProvider = ({ foreignEventId, foreignEventProvider, eventUuid, children }) => {
  const [postMeetingShare] = usePostMeetingShareMutation()
  const [patchMeetingSharePasscode] = usePatchMeetingSharePasscodeMutation()
  const [deleteMeetingSharePasscode] = useDeleteMeetingSharePasscodeMutation()
  const [shareUuid, setShareUuid] = useState(null)
  const [share, setShare] = useState(null)
  const user = useGetUserQuery()
  const track = useTrack()
  const addPasscode = useCallback(async () => {
    try {
      const response = await patchMeetingSharePasscode({ share_uuid: shareUuid }).unwrap()
      setShare(response)
    } catch (error) {
      console.error(error)
    }
  }, [patchMeetingSharePasscode, shareUuid])
  const deletePasscode = useCallback(async () => {
    try {
      const response = await deleteMeetingSharePasscode({ share_uuid: shareUuid }).unwrap()
      setShare(response)
    } catch (error) {
      console.error(error)
    }
  }, [deleteMeetingSharePasscode, shareUuid])
  const togglePasscode = useCallback(async () => {
    if (share?.accessLevel === 'Passcode') {
      await deletePasscode()
    } else {
      await addPasscode()
      dispatchSegmentEvent(
        track,
        user.data,
        foreignEventId,
        foreignEventProvider === 'Calendly',
        'user_added_passcode',
        eventUuid,
        { share_uuid: shareUuid }
      )
    }
  }, [addPasscode, deletePasscode, share, foreignEventId, foreignEventProvider, user.data, shareUuid, eventUuid, track])
  const context = useMemo(() => ({
    foreignEventId,
    eventUuid,
    foreignEventProvider,
    share,
    shareUuid,
    postMeetingShare,
    setShare,
    setShareUuid,
    togglePasscode,
  }), [foreignEventId, foreignEventProvider, share, shareUuid, postMeetingShare, togglePasscode, eventUuid])
  return (
    <ShareContext.Provider value={context}>
      {children}
    </ShareContext.Provider>
  )
}
